import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const colors = appPalette.colors;

export const useStyles = makeStyles({
  text_render: {
    ...(theme.themeName === 'honda' && {
      '&.no-font': {
        fontSize: 'inherit',
        fontFamily: 'inherit',
        lineHeight: 'inherit',
        letterSpacing: 'inherit',
      },
      '& *': {
        '&:not(.include-font)': {
          fontSize: 'inherit',
          fontFamily: 'inherit',
          lineHeight: 'inherit',
          letterSpacing: 'inherit',
        },
      },
    }),
  },
  link_container: {
    display: 'inline',
  },
  link_style: {
    textDecoration: 'underline',
    color: 'inherit',
    verticalAlign: 'bottom !important',
    '&:hover': {
      color: colors.acura_red,
      textDecoration: 'underline',
    },
  },
});
